import { create } from 'zustand';
import { LocalizationSettings, Language, Currency, UnitSystem } from '../types';
import i18n from '../i18n';

interface LocalizationState extends LocalizationSettings {
  setLanguage: (language: Language) => void;
  setCurrency: (currency: Currency) => void;
  setUnitSystem: (unitSystem: UnitSystem) => void;
}

export const useLocalizationStore = create<LocalizationState>((set) => ({
  language: 'en',
  currency: 'EUR',
  unitSystem: 'metric',
  
  setLanguage: (language) => {
    i18n.changeLanguage(language);
    set({ language });
  },
  
  setCurrency: (currency) => set({ currency }),
  
  setUnitSystem: (unitSystem) => set({ unitSystem })
}));